module.exports = __webpack_public_path__ + "media/personas/bg-content-search-a8fb446e.jpg";